var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReception(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4.00098,
    r: 2,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31345 12.0018C5.20232 11.0016 5.3568 8.83983 6.73476 8.10276C6.97354 7.97504 7.25977 8.01889 7.49508 8.1529L8.49087 8.72C8.79765 8.89471 9.17383 8.89471 9.48062 8.72L10.5286 8.12319C10.7327 8.00695 10.9769 7.95783 11.1843 8.06805C11.8807 8.43809 12.8394 9.59991 12.8394 12.0018M5.31345 12.0018H4.5C3.94772 12.0018 3.5 12.4495 3.5 13.0018L3.5 14.9199C3.5 15.4722 3.94772 15.9199 4.5 15.9199H4.95078M5.31345 12.0018H12.8394M12.8394 12.0018H15.1273M15.1273 12.0018C15.1273 12.0018 15 10.0018 17 10.0018M15.1273 12.0018H19M17 10.0018C19 10.0018 19 12.0018 19 12.0018M17 10.0018V8.50183M19 12.0018H20C20.5523 12.0018 21 12.4495 21 13.0018V14.9199C21 15.4722 20.5523 15.9199 20 15.9199H19.5492M17 8.50183H16.3653M17 8.50183H17.6347M4.95078 15.9199V20.907C4.95078 21.4593 5.39849 21.907 5.95078 21.907H18.5492C19.1015 21.907 19.5492 21.4593 19.5492 20.907V15.9199M4.95078 15.9199H19.5492",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReception);
export default __webpack_public_path__ + "static/media/reception.725634970cccc1e0911b9b42769444d6.svg";
export { ForwardRef as ReactComponent };